export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Справочник Перечень видов документов - Управленческие документы",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
